<template>
    <div class="item-date">
        <small>{{formatted}}</small>
    </div>
</template>

<script>
import {longDateFormatter} from '../../../../utils/formatter'

export default {
  name: 'ItemDay',
  props: {
    value: Date,
    default: new Date()
  },
  computed: {
    formatted: function () {
      return longDateFormatter(this.value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/common/itinerario/ItemDay.vue